<div class="passenger-day-bookings-container">
  <p-tabView>
    <p-tabPanel [header]="generalTabHeader">
      <p-table
        [value]="generalBookingsData"
        [loading]="isLoading"
        [rows]="50"
        [paginator]="generalBookingsData.length > 50"
        styleClass="p-datatable-sm mi-grid passenger-day-bookings-table passenger-day-bookings-table--general"
        [scrollable]="true"
        scrollHeight="400px">
        <ng-template pTemplate="header">
          <tr>
            <th class="col-booking-id">{{ labelBookingId }}</th>
            <th class="col-pickup-time">{{ labelPickupTime }}</th>
            <th class="col-pickup-drop">{{ labelPickupDropOff }}</th>
            <th class="col-driver">{{ labelDriver }}</th>
            <th class="col-status">{{ labelStatus }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr class="cursor-pointer" (click)="onGeneralRowClicked(row)">
            <td class="col-booking-id" [innerHTML]="renderCell(getGeneralBookingIdCell, row) | keepHtml"></td>
            <td class="col-pickup-time" [innerHTML]="renderCell(getGeneralPickupTimeCell, row) | keepHtml"></td>
            <td class="col-pickup-drop p-0" [innerHTML]="renderCell(getGeneralPickupDropCell, row) | keepHtml"></td>
            <td class="col-driver" [innerHTML]="renderCell(getGeneralDriverCell, row) | keepHtml"></td>
            <td class="col-status" [innerHTML]="renderCell(getGeneralStatusCell, row) | keepHtml"></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5" class="text-center">{{ labelNoRecords }}</td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>

    <p-tabPanel [header]="dedicatedTabHeader">
      <p-table
        [value]="dedicatedBookingsData"
        [loading]="isLoading"
        [rows]="50"
        [paginator]="dedicatedBookingsData.length > 50"
        styleClass="p-datatable-sm mi-grid passenger-day-bookings-table passenger-day-bookings-table--dedicated"
        [scrollable]="true"
        scrollHeight="400px">
        <ng-template pTemplate="header">
          <tr>
            <th class="col-booking-id">{{ labelBookingId }}</th>
            <th class="col-duration">{{ labelDuration }}</th>
            <!-- <th class="col-passenger">{{ labelPassenger }}</th> -->
            <th class="col-pickup-details">{{ labelPickupDetails }}</th>
            <th class="col-driver-vehicle">{{ labelDriverVehicleInfo }}</th>
            <th class="col-status">{{ labelStatus }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr class="cursor-pointer" (click)="onDedicatedRowClicked(row)">
            <td class="col-booking-id" [innerHTML]="renderCell(getDedicatedBookingIdCell, row) | keepHtml"></td>
            <td class="col-duration" [innerHTML]="renderCell(getDedicatedDurationCell, row) | keepHtml"></td>
            <!-- <td class="col-passenger" [innerHTML]="renderCell(getDedicatedPassengerCell, row) | keepHtml"></td> -->
            <td class="col-pickup-details" [innerHTML]="renderCell(getDedicatedPickupLocationCell, row) | keepHtml"></td>
            <td class="col-driver-vehicle" [innerHTML]="renderCell(getDedicatedDriverVehicleCell, row) | keepHtml"></td>
            <td class="col-status" [innerHTML]="renderCell(getDedicatedStatusCell, row) | keepHtml"></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5" class="text-center">{{ labelNoRecords }}</td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>
  </p-tabView>
</div>
